var anim;
var position = new Array();
var marqueur = new Array();
var contentString = new Array();
var infowindow = new Array();


if(navigator.appVersion.indexOf('Win')!=-1) $('html').addClass('pc');
if(navigator.appVersion.indexOf('Win')!=-1) $('.h-appartements').addClass('pc');
if(navigator.appVersion.indexOf('Win')!=-1) $('.h-services').addClass('pc');
if(navigator.appVersion.indexOf('Win')!=-1) $('.bloc-blog').addClass('pc');

function ready(fn) {
	if(document.readyState != 'loading') fn();
	else document.addEventListener('DOMContentLoaded', fn);
}



mailOK = function(mailteste) {
	var reg = new RegExp('^[a-z0-9]+([_|\.|-]{1}[a-z0-9]+)*@[a-z0-9]+([_|\.|-]{1}[a-z0-9]+)*[\.]{1}[a-z]{2,6}$', 'i');
	if(reg.test(mailteste)) return(true);
	else return(false);
}


okornot = function() {
	if(document.querySelector('input[name="c_prenom"]').value=='') document.querySelector('input[name="c_prenom"]').style.borderBottom = '1px solid red'; else document.querySelector('input[name="c_prenom"]').style.borderBottom = '1px solid #fff';
	if(document.querySelector('input[name="c_nom"]').value=='') document.querySelector('input[name="c_nom"]').style.borderBottom = '1px solid red'; else document.querySelector('input[name="c_nom"]').style.borderBottom = '1px solid #fff';
	if(mailOK(document.querySelector('input[name="c_email"]').value) == false) document.querySelector('input[name="c_email"]').style.borderBottom = '1px solid red'; else document.querySelector('input[name="c_email"]').style.borderBottom = '1px solid #fff';
	if(document.querySelector('input[name="c_telephone"]').value=='') document.querySelector('input[name="c_telephone"]').style.borderBottom = '1px solid red'; else document.querySelector('input[name="c_telephone"]').style.borderBottom = '1px solid #fff';
	if(document.querySelector('textarea[name="c_message"]').value=='') document.querySelector('textarea[name="c_message"]').style.borderBottom = '1px solid red'; else document.querySelector('textarea[name="c_message"]').style.borderBottom = '1px solid #fff';
	
	if(document.querySelector('input[name="c_prenom"]').value!='' && document.querySelector('input[name="c_nom"]').value!='' && mailOK(document.querySelector('input[name="c_email"]').value) && document.querySelector('input[name="c_telephone"]').value!='' && document.querySelector('textarea[name="c_message"]').value!='') {
		var request = new XMLHttpRequest();
		// attention nom theme et input c_lang
		request.open('GET', 'http://'+window.location.hostname+'/wp-content/themes/ambroisie/send.php?c_prenom='+encodeURIComponent(document.querySelector('input[name="c_prenom"]').value)+'&c_nom='+encodeURIComponent(document.querySelector('input[name="c_nom"]').value)+'&c_email='+encodeURIComponent(document.querySelector('input[name="c_email"]').value)+'&c_telephone='+encodeURIComponent(document.querySelector('input[name="c_telephone"]').value)+'&c_message='+encodeURIComponent(document.querySelector('textarea[name="c_message"]').value)+'&c_lang='+encodeURIComponent(document.querySelector('input[name="c_lang"]').value), true);
		request.onload = function() { if(request.status >= 200 && request.status < 400) document.querySelector('#reponse').innerHTML = request.responseText; }
		request.send();
	}
	return false;
}

scroll_anim = function() {

	if (window.innerWidth > 1024) {
		if($('body').hasClass('post-type-archive-location') || $('body').hasClass('post-type-archive-vente') || $('body').hasClass('page-template-t-en-gestion')) {

			var apttHeight = $('.aptt-list').height();
			var sideHeight = $('#mapZoneContainer').height();

			if(apttHeight > sideHeight) {
				if(pageYOffset>$('.aptt-list').offset().top)	$('#mapZoneContainer').css({'position': 'fixed', 'transform': 'translateY(0)', 'top': '0', 'left': '50%'});
				if(pageYOffset>($('.aptt-list').offset().top + apttHeight - sideHeight)) $('#mapZoneContainer').css({'position': 'relative', 'transform': 'translateY(0)', 'left' : '0', 'top': (apttHeight - sideHeight)});
				if(pageYOffset<$('.aptt-list').offset().top) $('#mapZoneContainer').css({'position' : 'relative', 'transform' : 'translateY(0)', 'left' : '0', 'top' : '0'});
			}

			if($('.aptt-post').hasClass('single')) {
				var apttHeight = $('.aptt-list').height();
				var sideHeight = $('#mapZoneContainer').height();

				if(apttHeight > sideHeight) {
					if(pageYOffset>$('.aptt-list').offset().top) $('#mapZoneContainer').css({'position': 'fixed', 'transform': 'translateY(0)', 'top': '0', 'left': '50%'});
					if(pageYOffset>($('.aptt-list').offset().top + apttHeight - sideHeight)) $('#mapZoneContainer').css({'position': 'relative', 'transform': 'translateY(0)', 'left' : '0', 'top': (apttHeight - sideHeight)});
					if(pageYOffset<$('.aptt-list').offset().top) $('#mapZoneContainer').css({'position' : 'relative', 'transform' : 'translateY(0)', 'left' : '0', 'top' : '0'});
				}
			}
		}

	}

	monRAF = requestAnimationFrame(scroll_anim);
}

menu_mobile = function() {
	$("#main-navigation").toggleClass('actived');
	$(".menu-mobile").toggleClass('is-open');
}


// ============================================================
// GOOGLE MAPS — fonction globale appelée par le callback async
// ============================================================
window.initializeGoogleMaps = function() {

	// Sécurité : on ne fait rien si l'élément #mapZone n'existe pas sur la page
	if (!document.getElementById("mapZone")) return;

	var styleArray =
	[
    {
        "stylers": [
            {
                "hue": "#ff1a00"
            },
            {
                "invert_lightness": true
            },
            {
                "saturation": -100
            },
            {
                "lightness": 33
            },
            {
                "gamma": 0.5
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#2D333C"
            }
        ]
    }
	];

	var centreCarte = new google.maps.LatLng(43.5986415,1.4470018);
	var optionsCarte = { zoom: 13, disableDefaultUI:true, center: centreCarte, scrollwheel: false, zoomControl: true};
	var maCarte = new google.maps.Map(document.getElementById("mapZone"), optionsCarte);
	maCarte.setOptions({styles: styleArray});

	if (typeof coord_aptt !== 'undefined') {
		for(i=0; i<coord_aptt.length; i++) {
			if(coord_aptt[i][1]!='' && coord_aptt[i][2]!='') {
				position[i] = new google.maps.LatLng(coord_aptt[i][1], coord_aptt[i][2]);
				marqueur[i] = new google.maps.Marker({ position: position[i], map: maCarte, title: coord_aptt[i][3], icon: theme_url + '/img/marker.svg'});
			}
		}
	}
}
// ============================================================


$(document).ready(function() {
		$('section.aptt-post').hide();
		$('section.aptt-post.disponible').show();
	

	$(document).on('click', '.selector-gestion', function(event) {
		$('section.aptt-post').show();

		$('.selector-dispo').removeClass('actif');
		$('.selector-gestion').addClass('actif');
	});
	$(document).on('click', '.selector-dispo', function(event) {
		$('section.aptt-post').hide();
		$('section.aptt-post.disponible').show();
		
		$('.selector-gestion').removeClass('actif');
		$('.selector-dispo').addClass('actif');
	});


	/* OWL */
	$('.owl-carousel').each(function(index) {
		$(this).owlCarousel({
			singleItem: true,
			slideSpeed: 1000,
			autoPlay: true,
			loop: true,
      autoPlaySpeed: 2000,
      autoPlayTimeout: 2000,
      autoplayHoverPause: true
		});
		$(this).parent().find('.prev').click(function(){ $('.owl-carousel:eq('+index+')').trigger('owl.prev'); });
		$(this).parent().find('.next').click(function(){ $('.owl-carousel:eq('+index+')').trigger('owl.next'); });
	});



	$('#mapZoneContainer').css({'position' : 'relative', 'transform' : 'translateY(0)', 'left' : '0', 'top' : '0'});
	$(".wrapper h1").append($('<span class="gold-txt">.</span>'));


	$('.menu-mobile').click(menu_mobile);

	var resizeTimer;
	$(window).on('resize', function() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function() {
			if (window.innerWidth > 1024) {
				$('#main-navigation').removeClass('actived');
				$('.menu-mobile').removeClass('is-open');
			}
			$('.owl-carousel').each(function() {
				var owl = $(this).data('owlCarousel');
				if (owl && typeof owl.reinit === 'function') owl.reinit();
			});
		}, 200);
	});

	monRAF = requestAnimationFrame(scroll_anim);

});


montrer_apt_index = function(numero) {

	if($('.single').length) var dest_y = $('.left-container').offset().top + $('section.aptt-post').height()*numero;
	else var dest_y = $('.left-container').offset().top + $('section.aptt-post').height()*numero/2;

	if(dest_y > $(document).height() - $('footer').height() - 40 - 100) return;

	$('html,body').animate({scrollTop:dest_y + 'px'}, 500);
}


$('section.aptt-post').each(function(index) {
	$('section.aptt-post:eq('+index+')').hover(function() {
		if(marqueur[index]!=undefined) marqueur[index].setIcon(theme_url + '/img/marker-white.svg');
	}, function() {
		if(marqueur[index]!=undefined) marqueur[index].setIcon(theme_url + '/img/marker.svg');
	});
});

	

$(document).on('click', '.onglets-title1', function() {
  if($(this).hasClass('onglet-t1')) {
  	$('.onglets-content1').hide(); $('.onglet-c1').show();
  }
  else if($(this).hasClass('onglet-t2')) {
  	$('.onglets-content1').hide(); $('.onglet-c2').show();
  }
  else if($(this).hasClass('onglet-t3')) {
  	$('.onglets-content1').hide(); $('.onglet-c3').show();
  }
  else if($(this).hasClass('onglet-t4')) {
  	$('.onglets-content1').hide(); $('.onglet-c4').show();
  }
  else if($(this).hasClass('onglet-t5')) {
  	$('.onglets-content1').hide(); $('.onglet-c5').show();
  }
  else if($(this).hasClass('onglet-t6')) {
  	$('.onglets-content1').hide(); $('.onglet-c6').show();
  }
});

$(document).on('click', '.onglets-title2', function() {
  if($(this).hasClass('onglet2-t1')) {
  	$('.onglets-content2').hide(); $('.onglet2-c1').show();
  }
  else if($(this).hasClass('onglet2-t2')) {
  	$('.onglets-content2').hide(); $('.onglet2-c2').show();
  }
});


$(document).ready(function() {
		// sliding nav
		if( window.innerWidth > 1024 ){
			var slide_nav = $('#hover-line');
			var current_pos = 0;
			var current_menu_width = 0;
			
			$('header #navigation ul > li.current-menu-item:not(.menu-item-home), header #navigation ul > li.current_page_item:not(.menu-item-home)').each(function(){
				var top_pos = $(this).position().top + 17;
				var padding = parseInt($(this).css('padding-left'));
				var margin = parseInt($(this).css('margin-left'));
				
				current_pos = $(this).position().left + padding + margin;
				current_menu_width = $(this).width();

				slide_nav.css({'width': current_menu_width, 'left': current_pos, 'top':  top_pos});
			});

			$(window).scroll(function() {
				if($('#main-navigation').hasClass('fixed')) {
					$('header #navigation ul > li.current-menu-item:not(.menu-item-home), header #navigation ul > li.current_page_item:not(.menu-item-home)').each(function(){
						var top_pos = $(this).position().top + 17;
						var padding = parseInt($(this).css('padding-left'));
						var margin = parseInt($(this).css('margin-left'));
						
						current_pos = $(this).position().left + padding + margin;
						current_menu_width = $(this).width();

						slide_nav.css({'width': current_menu_width, 'left': current_pos, 'top':  top_pos});
					});
				} else {
					$('header #navigation ul > li.current-menu-item:not(.menu-item-home), header #navigation ul > li.current_page_item:not(.menu-item-home)').each(function(){
						var top_pos = $(this).position().top + 17;
						var padding = parseInt($(this).css('padding-left'));
						var margin = parseInt($(this).css('margin-left'));
						
						current_pos = $(this).position().left + padding + margin;
						current_menu_width = $(this).width();

						slide_nav.css({'width': current_menu_width, 'left': current_pos, 'top':  top_pos});
					});
				}
			});

			$(window).resize(function(){
				$('header #navigation ul > li.current-menu-item:not(.menu-item-home), header #navigation ul > li.current_page_item:not(.menu-item-home)').each(function(){
					var top_pos = $(this).position().top + 17;
					var padding = parseInt($(this).css('padding-left'));
					var margin = parseInt($(this).css('margin-left'));

					current_pos = $(this).position().left + padding + margin;
					current_menu_width = $(this).width();

					slide_nav.css({'width': current_menu_width, 'left': current_pos, 'top':  top_pos});
				});
			});
				
			$('header #navigation ul > li').hover(function(){
				var padding_left = parseInt($(this).css('padding-left'));
				var margin_left = parseInt($(this).css('margin-left'));

				slide_nav.animate({ 'width': jQuery(this).width(), 'left': jQuery(this).position().left + padding_left + margin_left}, 
					{ queue: false, easing: 'easeOutQuad', duration: 250 });			
			}, function(){
				slide_nav.animate({ 'width': current_menu_width, 'left': current_pos}, 
					{ queue: false, easing: 'easeOutQuad', duration: 250 });		
			});	

			$(window).trigger('resize');
			$(window).trigger('scroll');
		}
});


$(document).ready(function() {
  if( window.innerWidth > 1024 ){
  	$(window).bind('scroll', function() {
    if($(window).scrollTop() > 169){
      $('#main-navigation').addClass('fixed');
    }else{
      $('#main-navigation').removeClass('fixed');
    }
  })
  }
});

$(window).on('load', function() {
	setTimeout(function() {
		$('.preloader').fadeOut(500);
		$('.preloader').css('display','none');
		$('body').removeClass('preload');
		$('body').addClass('loaded');
	}, 1500);
});

document.addEventListener('DOMContentLoaded', function () {
	const galleries = document.querySelectorAll('.slide-container');
	const modal = document.getElementById('image-modal');
	const modalImage = document.getElementById('modal-image');
	const closeModal = document.querySelector('.modal .close');
	const prevButton = document.getElementById('prev-image');
	const nextButton = document.getElementById('next-image');

	let currentIndex = 0;
	let currentGalleryImages = [];

	function openModal(index) {
		currentIndex = index;
		const imageSrc = currentGalleryImages[currentIndex].getAttribute('data-fullsize');
		modalImage.setAttribute('src', imageSrc);
		modal.style.display = 'block';
		document.body.classList.add('modal-open', 'no-scroll');
	}

	function closeModalHandler() {
		modal.style.display = 'none';
		document.body.classList.remove('modal-open', 'no-scroll');
	}

	function showPrevImage() {
		currentIndex = (currentIndex - 1 + currentGalleryImages.length) % currentGalleryImages.length;
		openModal(currentIndex);
	}

	function showNextImage() {
		currentIndex = (currentIndex + 1) % currentGalleryImages.length;
		openModal(currentIndex);
	}

	galleries.forEach((gallery) => {
		const images = gallery.querySelectorAll('img');
		images.forEach((img, index) => {
			img.addEventListener('click', (event) => {
				event.preventDefault();
				event.stopPropagation();
				currentGalleryImages = Array.from(images);
				openModal(index);
			});
		});
	});

	// ✅ CORRIGÉ : vérification null avant addEventListener
	if (closeModal) closeModal.addEventListener('click', closeModalHandler);
	if (prevButton) prevButton.addEventListener('click', showPrevImage);
	if (nextButton) nextButton.addEventListener('click', showNextImage);

	if (modal) {
		window.addEventListener('click', (event) => {
			if (event.target === modal) {
				closeModalHandler();
			}
		});
	}
});
